import { Component, computed, input, OnInit, output, signal, viewChild } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { RidAudioButton } from '../../components/rid-audio-button/rid-audio-button';
import { RidBottomButton } from '../../components/rid-bottom-button/rid-bottom-button';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicTitle } from '../../components/rid-mechanic-title/rid-mechanic-title';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidReadingCountdown } from '../../components/rid-reading-countdown/rid-reading-countdown';
import { RidSegmentedWordCard } from '../../components/rid-segmented-word-card/rid-segmented-word-card';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';

@Component({
  selector: 'rid-reading-basis-instruction-mode',
  imports: [
    RidMechanicBackground,
    RidMechanicWrapper,
    RidTopBar,
    RidMechanicContent,
    RidMechanicTitle,
    RidAudioButton,
    RidBottomButton,
    RidSegmentedWordCard,
    RidReadingCountdown,
  ],
  templateUrl: './rid-reading-basis-instruction-mode.html',
  host: {
    class: 'block',
  },
})
export class RidReadingBasisInstructionMode implements OnInit {
  instruction = input.required<string>();
  words = input.required<{ word: string[]; audio: string }[]>();
  pace = input.required<number>();

  index = signal(0);
  word = computed(() => this.words()[this.index()]);
  countdown = viewChild.required<RidReadingCountdown>('countdown');
  card = viewChild.required<RidSegmentedWordCard>('card');
  state = signal<'READING' | 'DONE' | 'EVALUATING'>('READING');
  showCountdown = signal(true);

  finished = output<void>();

  ngOnInit(): void {
    this.pass();
  }

  async pass() {
    this.state.set('READING');
    this.showCountdown.set(true);
    await delay(500);

    await this.countdown().countdown(this.pace());
    await this.card().pass(this.pace(), () => this.showCountdown.set(false));
    await delay(this.pace());
    await this.card().hide();
    this.state.set('DONE');
  }

  evaluate() {
    this.state.set('EVALUATING');
    this.card().show();
  }

  next() {
    if (this.index() >= this.words().length - 1) {
      this.finish();
      return;
    }

    this.index.update((i) => i + 1);
    this.pass();
  }

  finish() {
    this.finished.emit();
  }
}
